import React from "react";
import styled from "styled-components";

/*
  disable: boolean
  placeholder: string
  onChange: void
  defaultValue: string

  rIconView: boolean
  rIcon: string
  rIconEvent: void
*/

const InputText = props => {
  return (
    <Container
      disable={props.disable}
      state={props.state}
      style={props.inputStyle ? props.inputStyle : {}}>
      {/* {props.text} */}
      <Input
        type={props.type}
        pattern={props.pattern}
        placeholder={props.placeholder}
        disable={props.disable}
        value={props.defaultValue ? props.defaultValue : ""}
        onChange={props.onChange}
        readOnly={props.disable}
        style={props.inputStyle ? props.inputStyle : {}}
        onKeyUp={props.enterEvent ? props.enterEvent : ""}
      />

      {props.rIconView && (
        <img
          src={props.rIcon}
          onClick={props.rIconEvent}
          style={{ width: "14px" }}
        />
      )}
    </Container>
  );
};

/* Sample
  <InputText 
    disable=<boolean>
    placeholder=<string>
    defaultValue=<string>

    rIconView=<boolean>
    rIcon=<string>
    rIconEvent=<boid>
  /> 
*/

const Container = styled.div`
  display: flex;
  width: calc(100% - 32px);
  /* height: 52px; */
  padding: 14px 16px;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;

  border-radius: 6px;
  border: ${props =>
    props.state === "error" ? "1px solid #ff6259" : "1px solid #d0d0d0"};
  background: ${props => (props.disable ? "#fafafa" : "#fff")};

  color: #888;
`;

const Input = styled.input`
  border: 0px;
  width: 100%;
  height: 22px;
  background: ${(props) => (props.disable ? "#fafafa" : "#fff")};

  /* Body/2/Regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 157.143% */
  letter-spacing: -0.28px;
`;
export default InputText;
